
export class Constants {
    // public static REST_API_MAIN: string = 'http://localhost:5000';
    public static REST_API_MAIN: string = 'https://lms-mk-api.achatsocial.com'; // bangwa
    public static REST_API_SW: string = 'https://rl-1243.achatsocial.com'; // bangwa province
}
